// src/pages/Consultation/config/consultationMenuConfig.js

import {
  ClipboardCheckIcon,
  VideoCameraIcon,
  DocumentTextIcon,
  UserGroupIcon,
  ChartSquareBarIcon,
  PlayIcon,
  ClockIcon,
  DocumentReportIcon,
  CashIcon,
  CalendarIcon,
} from "@heroicons/react/outline";
import {
  FiVideo,
  FiFileText,
  FiUsers,
  FiActivity,
  FiCalendar,
  FiDollarSign,
  FiClock,
} from "react-icons/fi";
import {
  CONSULTATION_ROUTES,
  CONSULTATION_PERMISSIONS,
} from "../constants/consultation.constant";

// ========================================
// CONSULTATION MENU GROUP
// ========================================
export const CONSULTATION_MENU_GROUP = {
  id: "consultation",
  translationKey: "menu.groups.consultation",
  icon: ClipboardCheckIcon,
  color: {
    bg: "bg-purple-500",
    hover: "hover:bg-purple-600",
    light: "bg-purple-50",
    text: "text-purple-600",
    border: "border-purple-500",
  },
  expanded: false,
  featureFlag: "consultation",
  items: [
    {
      path: CONSULTATION_ROUTES.DASHBOARD,
      translationKey: "menu.items.consultation_dashboard",
      descriptionKey: "menu.descriptions.consultation_dashboard",
      icon: FiActivity,
      permissions: [CONSULTATION_PERMISSIONS.VIEW_CONSULTATIONS, "ADMIN"],
      featureFlag: "consultationDashboard",
      badge: { type: "info", count: 0 }, // Active consultations count
    },
    {
      path: CONSULTATION_ROUTES.START_SESSION,
      translationKey: "menu.items.start_session",
      descriptionKey: "menu.descriptions.start_session",
      icon: PlayIcon,
      permissions: [CONSULTATION_PERMISSIONS.START_CONSULTATION, "ADMIN"],
      featureFlag: "startConsultation",
    },
    // Note: Session Details is accessible via dashboard/session list, not a direct menu item

    // Future menu items (ready to uncomment when screens are built)
    // {
    //   path: CONSULTATION_ROUTES.ACTIVE_SESSIONS,
    //   translationKey: "menu.items.active_sessions",
    //   descriptionKey: "menu.descriptions.active_sessions",
    //   icon: FiVideo,
    //   permissions: [CONSULTATION_PERMISSIONS.VIEW_CONSULTATIONS],
    //   featureFlag: "activeConsultations",
    //   badge: { type: "success", count: 0 },
    // },
    // {
    //   path: CONSULTATION_ROUTES.SESSION_HISTORY,
    //   translationKey: "menu.items.session_history",
    //   descriptionKey: "menu.descriptions.session_history",
    //   icon: FiClock,
    //   permissions: [CONSULTATION_PERMISSIONS.VIEW_CONSULTATIONS],
    //   featureFlag: "consultationHistory",
    // },
    // {
    //   path: CONSULTATION_ROUTES.REPORTS,
    //   translationKey: "menu.items.consultation_reports",
    //   descriptionKey: "menu.descriptions.consultation_reports",
    //   icon: DocumentReportIcon,
    //   permissions: [CONSULTATION_PERMISSIONS.VIEW_CONSULTATION_REPORTS, "ADMIN"],
    //   featureFlag: "consultationReports",
    // },
    // {
    //   path: CONSULTATION_ROUTES.BILLING,
    //   translationKey: "menu.items.consultation_billing",
    //   descriptionKey: "menu.descriptions.consultation_billing",
    //   icon: FiDollarSign,
    //   permissions: [CONSULTATION_PERMISSIONS.GENERATE_INVOICE, "ADMIN"],
    //   featureFlag: "consultationBilling",
    // },
    // {
    //   path: CONSULTATION_ROUTES.ANALYTICS,
    //   translationKey: "menu.items.consultation_analytics",
    //   descriptionKey: "menu.descriptions.consultation_analytics",
    //   icon: ChartSquareBarIcon,
    //   permissions: [CONSULTATION_PERMISSIONS.VIEW_CONSULTATION_ANALYTICS, "ADMIN"],
    //   featureFlag: "consultationAnalytics",
    // },
  ],
};

// ========================================
// QUICK ACCESS ITEMS FOR CONSULTATION
// ========================================
export const CONSULTATION_QUICK_ACCESS = [
  // {
  //   path: CONSULTATION_ROUTES.START_SESSION,
  //   translationKey: "menu.quick_access.start_consultation",
  //   icon: PlayIcon,
  //   color: "bg-gradient-to-r from-purple-500 to-indigo-600",
  //   permissions: [CONSULTATION_PERMISSIONS.START_CONSULTATION],
  //   isSpecial: true,
  //   featureFlag: "quickAccessStartConsultation",
  // },
  // {
  //   path: CONSULTATION_ROUTES.ACTIVE_SESSIONS,
  //   translationKey: "menu.quick_access.active_sessions",
  //   icon: FiVideo,
  //   color: "bg-gradient-to-r from-green-500 to-teal-600",
  //   permissions: [CONSULTATION_PERMISSIONS.VIEW_CONSULTATIONS],
  //   isSpecial: true,
  //   featureFlag: "quickAccessActiveSessions",
  //   badge: { type: "success", dynamic: true },
  // },
];

// ========================================
// CONSULTATION FEATURE FLAGS
// ========================================
export const CONSULTATION_FEATURE_FLAGS = {
  consultation: true,
  consultationDashboard: true,
  startConsultation: true,

  // Future features (set to false until implemented)
  activeConsultations: false,
  consultationHistory: false,
  consultationCalendar: false,
  consultationReports: false,
  consultationBilling: false,
  consultationAnalytics: false,
  quickAccessStartConsultation: false,
  quickAccessActiveSessions: false,
};
